import { render, staticRenderFns } from "./category.vue?vue&type=template&id=2b6c3ee7&scoped=true"
import script from "./category.vue?vue&type=script&lang=ts"
export * from "./category.vue?vue&type=script&lang=ts"
import style0 from "./category.vue?vue&type=style&index=0&id=2b6c3ee7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c3ee7",
  null
  
)

export default component.exports